import Image from 'next/image';

import { ampli } from '../../../../../core/Tracking/Amplitude/__AUTO_GENERATED__';
import {
    TrackingProperties,
    useTrackEventAmplitude,
} from '../../../../../core/Tracking/Amplitude/Amplitude';
import { Ratio, RATIO } from '../../../../../design-system/components/ratio/Ratio';
import { Typography } from '../../../../../design-system/components/typography/Typography';
import { imageLoaderForPath } from '../../../../../domains/Layout/Image/URL/ImageURL';
import { HomePageDocument } from '../../../../../resources/homePageDocument/domain/types/homePageDocument';

import style from './BrandNewsCard.module.css';

type BrandCommunicationCardProps = {
    brandCommunication: HomePageDocument['brandNews'][number];
    trackingInformation: {
        click: Pick<TrackingProperties<typeof ampli.brandCardClicked>, 'block' | 'card_number'>;
    };
};

export function BrandCommunicationCard({
    brandCommunication,
    trackingInformation,
}: BrandCommunicationCardProps) {
    const { trackEvent } = useTrackEventAmplitude();

    return (
        <div className={style.card}>
            <div className={style.header}>
                <a
                    className={style.link}
                    href={brandCommunication.link.url}
                    onClick={() => {
                        trackEvent((ampli, defaultProperties) => {
                            ampli.brandCardClicked({
                                ...defaultProperties,
                                ...trackingInformation.click,
                            });
                        });
                    }}
                >
                    <Image
                        alt=""
                        className={style.titleIcon}
                        src="/separators/star-patch.png"
                        width={21}
                        height={17}
                        loading="lazy"
                        loader={imageLoaderForPath}
                    />
                    <Typography as="h3" scale="primary-body-bold">
                        {brandCommunication.title}
                    </Typography>
                </a>
                <Typography as="div" scale="primary-xxs-regular">
                    {brandCommunication.description}
                </Typography>
            </div>
            <div className={style.pictureWrapper}>
                <Ratio ratio={RATIO['5/4']}>
                    <img
                        src={brandCommunication.picture.card_cover.url}
                        alt={brandCommunication.picture.alt}
                        srcSet={`${brandCommunication.picture.card_cover_retina.url} 2x`}
                        sizes="300px"
                        loading="lazy"
                        className={style.picture}
                    />
                </Ratio>
            </div>
        </div>
    );
}
